/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tooltip_Techsource2Inputs */

const id_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menggunakan`)
};

const ms_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menggunakan`)
};

const da_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruger`)
};

const de_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden`)
};

const en_us2_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the`)
};

const es_es2_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos la`)
};

const es_mx2_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos`)
};

const fil_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginagamit namin ang`)
};

const fr_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons`)
};

const it_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usiamo`)
};

const hu_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Használjuk a`)
};

const nl_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken`)
};

const no_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruker`)
};

const pl_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korzystamy z`)
};

const pt_br2_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós usamos o`)
};

const pt_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos a`)
};

const ro_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folosim`)
};

const fi_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytämme`)
};

const sv_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi använder`)
};

const vi_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi sử dụng`)
};

const tr_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şunu kullanıyoruz:`)
};

const cs_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Používáme`)
};

const bg_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Използваме`)
};

const ru_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы используем`)
};

const uk_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми використовуємо`)
};

const ar_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نستخدم`)
};

const hi_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम उपयोग करते हैं`)
};

const th_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราใช้`)
};

const ja_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用元：`)
};

const zh_cn2_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们使用`)
};

const zh_hant1_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們使用`)
};

const ko_offerdetail_tooltip_techsource2 = /** @type {(inputs: Offerdetail_Tooltip_Techsource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음을 사용합니다`)
};

/**
* | output |
* | --- |
* | "We use the" |
*
* @param {Offerdetail_Tooltip_Techsource2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tooltip_techsource2 = /** @type {((inputs?: Offerdetail_Tooltip_Techsource2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tooltip_Techsource2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tooltip_techsource2(inputs)
	if (locale === "ms") return ms_offerdetail_tooltip_techsource2(inputs)
	if (locale === "da") return da_offerdetail_tooltip_techsource2(inputs)
	if (locale === "de") return de_offerdetail_tooltip_techsource2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tooltip_techsource2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tooltip_techsource2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tooltip_techsource2(inputs)
	if (locale === "fil") return fil_offerdetail_tooltip_techsource2(inputs)
	if (locale === "fr") return fr_offerdetail_tooltip_techsource2(inputs)
	if (locale === "it") return it_offerdetail_tooltip_techsource2(inputs)
	if (locale === "hu") return hu_offerdetail_tooltip_techsource2(inputs)
	if (locale === "nl") return nl_offerdetail_tooltip_techsource2(inputs)
	if (locale === "no") return no_offerdetail_tooltip_techsource2(inputs)
	if (locale === "pl") return pl_offerdetail_tooltip_techsource2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tooltip_techsource2(inputs)
	if (locale === "pt") return pt_offerdetail_tooltip_techsource2(inputs)
	if (locale === "ro") return ro_offerdetail_tooltip_techsource2(inputs)
	if (locale === "fi") return fi_offerdetail_tooltip_techsource2(inputs)
	if (locale === "sv") return sv_offerdetail_tooltip_techsource2(inputs)
	if (locale === "vi") return vi_offerdetail_tooltip_techsource2(inputs)
	if (locale === "tr") return tr_offerdetail_tooltip_techsource2(inputs)
	if (locale === "cs") return cs_offerdetail_tooltip_techsource2(inputs)
	if (locale === "bg") return bg_offerdetail_tooltip_techsource2(inputs)
	if (locale === "ru") return ru_offerdetail_tooltip_techsource2(inputs)
	if (locale === "uk") return uk_offerdetail_tooltip_techsource2(inputs)
	if (locale === "ar") return ar_offerdetail_tooltip_techsource2(inputs)
	if (locale === "hi") return hi_offerdetail_tooltip_techsource2(inputs)
	if (locale === "th") return th_offerdetail_tooltip_techsource2(inputs)
	if (locale === "ja") return ja_offerdetail_tooltip_techsource2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tooltip_techsource2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tooltip_techsource2(inputs)
	return ko_offerdetail_tooltip_techsource2(inputs)
});
export { offerdetail_tooltip_techsource2 as "offerDetail.tooltip.techSource" }